export { getAssetDefaults, setDynamicFavicon, FaviconAsset } from './lib/util'
export * from '../types'
